var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-component',{attrs:{"dialogData":_vm.dialogData,"isShow":_vm.isShow,"width":"800"}},[_c('article-html',{attrs:{"content":_vm.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }